import axios from "axios";
import { ApiConfig } from "../constants/apiConfig";
import { studentAuthorizationHeaders } from './authService';

export const fetchJurnalHarian = async (siswaId, page = 1) => {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jurnal-harian`, {
      params: { siswa_id: siswaId, page },
      headers: studentAuthorizationHeaders(),
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Gagal mengambil data jurnal",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message || "Terjadi kesalahan saat mengambil data jurnal",
    };
  }
};

export const downloadJurnalHarian = async (siswaId, tanggalMulai, tanggalSelesai) => {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/export/jurnal-harian/download`, {
      params: {
        siswa_id: siswaId,
        tanggal_mulai: tanggalMulai,
        tanggal_selesai: tanggalSelesai,
      },
      headers: studentAuthorizationHeaders({ Accept: 'application/pdf' }),
      responseType: "blob",
    });

    return { success: true, blob: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Gagal mengunduh jurnal",
    };
  }
};

export const ajukanJurnalHarian = async ({ tanggal, pekerjaan, catatan, siswa_id }) => {
  try {
    const response = await axios.post(
      `${ApiConfig.baseUrl}/jurnal-harian`,
      { tanggal, pekerjaan, catatan, siswa_id },
      {
        headers: studentAuthorizationHeaders(),
      }
    );

    if (response.status === 201 && response.data.success) {
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        message: response.data.message || "Gagal menyimpan jurnal harian",
      };
    }
  } catch (error) {
    if (error.response?.status === 409) {
      return {
        success: false,
        message: "Jurnal harian sudah diisi di tanggal yang sama.",
      };
    }

    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat menyimpan jurnal harian",
    };
  }
};

export const updateJurnalHarian = async (id, { tanggal, pekerjaan, catatan, siswa_id }) => {
  try {
    const response = await axios.put(`${ApiConfig.baseUrl}/jurnal-harian/${id}`, {
      tanggal, pekerjaan, catatan, siswa_id,
    }, { headers: studentAuthorizationHeaders() });
    return { success: response.data?.success === true, message: response.data?.message || 'Jurnal diperbarui.' };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Gagal memperbarui jurnal harian.',
    };
  }
};

export const hapusJurnalHarian = async (id) => {
  try {
    const response = await axios.delete(`${ApiConfig.baseUrl}/jurnal-harian/${id}`, {
      headers: studentAuthorizationHeaders(),
    });
    return { success: response.data?.success === true, message: response.data?.message || 'Jurnal dihapus.' };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || error.message || 'Gagal menghapus jurnal.' };
  }
};
